import Continue from '../continue';
import CancelOrder from '../cancelOrder';
import ReturnToSales from '../returnToSales';
import Locked from '../Locked';

export const salesRep = {
  INCOMPLETE: [Continue, CancelOrder],
  SUBMITTED: [Locked]
};

export const admin = {
  INCOMPLETE: [Continue, CancelOrder],
  SUBMITTED: [Continue, ReturnToSales, CancelOrder]
};
